var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-tab",class:_vm.prefixCls},[_c('div',{staticClass:"weui-navbar"},_vm._l((_vm.datas),function(item,index){return _c('div',{key:index,staticClass:"weui-navbar__item",class:{'weui-bar__item_on':index===_vm.selectedIndex},domProps:{"innerHTML":_vm._s(item)},on:{"click":function($event){_vm.clickHandler(index)}}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f9aec55","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/navbar.vue
// module id = 303
// module chunks = 0